import QRCode from "react-qr-code"
import { numberToWords, formatPrice, invoiceCalculate } from "../../../utils/Common"

import "./../../InvoiceDetailPage/PdfHtmlContent/PdfHtmlContent.css"

const DeliveryInvoice = (props) => {
  const { invoice, invoiceSetting, shop_logo, invoiceImeis, id, inputs } = props
  invoice?.data?.user_info?.invoice_settings?.web_address
  const userInfo = invoice.user_info
  const user = JSON.parse(localStorage.getItem("user"));

  // // uncomment
  const BASE_URL = process.env.REACT_APP_ROOT_URL
  const invoiceDate = new Date(invoice.created_at)
  const year = invoiceDate.getFullYear()
  const month = String(invoiceDate.getMonth() + 1).padStart(2, "0")
  const day = String(invoiceDate.getDate()).padStart(2, "0")
  const hours = String(invoiceDate.getHours() % 12).padStart(2, "0")
  const minutes = String(invoiceDate.getMinutes()).padStart(2, "0")
  const ampm = invoiceDate.getHours() >= 12 ? "PM" : "AM"
  //const shop_logo = `${BASE_URL}/layoutlogo.svg`;
  const formattedDate = `${year}-${month}-${day}`
  const processedProductIds = new Set()
  const imeisByProduct = []

  // Aggregate unique IMEIs with all details
  invoiceImeis.forEach((imei) => {
    const imeiValue = imei.imei.toString().trim() // Normalize the IMEI

    // Check if the IMEI already exists in imeisByProduct
    const imeiExists = imeisByProduct.some((imeiDetail) => imeiDetail.imei === imeiValue)

    if (!imeiExists) {
      // If the IMEI doesn't exist, add it to imeisByProduct
      imeisByProduct.push({
        product_id: imei.product_id,
        product_name: imei.product_name,
        imei: imei.imei,
        sale_price: imei.sale_price,
        purchase_price: imei.purchase_price,
        base_currency_code: imei.base_currency_code,
        currency_rate: imei.currency_rate,
        purchase_currency_code: imei.purchase_currency_code,
        box_status: imei.box_status ?? "",
      })
    }
  })

  const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}${ampm}`
  let totalQty = 0
  let totalItems = 0
  let totalPrice = 0
  // let filteredDeliveryInfo = invoice?.delivery_method?.delivery_infos?.find((item) => item.id == invoice.delivery_info_id);
  const filteredDeliveryInfo = invoice?.delivery_method?.delivery_infos?.[0]

  return (
    <div id="pdfConentAreas" className="pdfConentAreas">
      <div id="invoice-detail-page" className="invoice-detail-page font-nunito">
        {/* Header Section - Redesigned for mobile */}
        <div className="md:flex md:justify-between md:items-center pt-4 pb-1 border-b-4 border-blue-300">
          {/* Mobile Layout */}
          <div className="md:hidden">
            {/* Logo and Invoice Title */}
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center">
                <img
                  src={shop_logo || "/placeholder.svg"}
                  alt="Shop Logo"
                  className="w-[40px] sm:w-[50px] object-contain mr-3"
                />
                <span className="font-semibold text-sm sm:text-base" style={{ letterSpacing: "0.08em" }}>
                  Sale Invoice
                </span>
              </div>
              <div className="w-[45px] sm:w-[55px]">
                <QRCode
                  className="w-full object-contain"
                  value={BASE_URL + "/invoice/" + invoice?.data?.invoice_id}
                  size={100}
                />
              </div>
            </div>

            {/* Company Info - Card Style */}
            <div className="bg-gray-50 rounded-md p-3 mb-2 shadow-sm">
              <div className="text-center mb-1">
                <span className="font-semibold text-base sm:text-lg block" style={{ letterSpacing: "0.05em" }}>
                  {invoiceSetting?.shop_name}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-1 text-xs">
                <div className="flex items-center">
                  <span className="font-medium mr-1">Phone:</span>
                  <span className="text-gray-600">{invoice?.user_info?.phone}</span>
                </div>
                <div className="flex items-center">
                  <span className="font-medium mr-1">Email:</span>
                  <span className="text-gray-600 truncate">{invoice?.user_info?.email}</span>
                </div>
                <div className="col-span-2 flex items-start">
                  <span className="font-medium mr-1">Address:</span>
                  <span className="text-gray-600">{invoiceSetting?.shop_address}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Desktop Layout */}
          <div className="hidden md:flex md:w-1/3 md:flex-col md:justify-start md:items-start">
            <img src={shop_logo || "/placeholder.svg"} alt="Shop Logo" className="w-[80px] object-contain" />
            <p className="mt-2">
              <span className="font-semibold text-lg" style={{ letterSpacing: "0.08em" }}>
                Sale Invoice
              </span>
            </p>
          </div>

          <div className="hidden md:flex md:w-1/3 md:justify-center md:pb-2">
            <div className="w-[100px]">
              <QRCode
                className="w-full object-contain"
                value={BASE_URL + "/invoice/" + invoice?.data?.invoice_id}
                size={100}
              />
            </div>
          </div>

          <div className="hidden md:flex md:w-1/3 md:flex-col md:justify-end md:items-end">
            <span className="font-semibold text-2xl" style={{ letterSpacing: "0.08em" }}>
              {invoiceSetting?.shop_name}
            </span>
            <span className="text-sm text-gray-600">
              <strong>Phone:</strong> {invoice?.user_info?.phone}
            </span>
            <span className="text-sm text-gray-600">
              <strong>Email:</strong> {invoice?.user_info?.email}
            </span>
            <span className="text-sm text-gray-600">
              <strong>Address:</strong> {invoiceSetting?.shop_address}
            </span>
          </div>
        </div>
        {/* Customer and Delivery Info Section - Redesigned for mobile */}
        <div className="md:flex md:flex-row md:items-center md:justify-between mt-4">
          {/* Mobile Layout */}
          <div className="md:hidden space-y-4">
            {/* Customer Info Card */}
            <div className="bg-white rounded-lg border border-gray-200 p-3 shadow-sm">
              <div className="border-b border-gray-100 pb-2 mb-2">
                <h3 className="font-semibold text-sm text-gray-800">Customer Information</h3>
              </div>
              <div className="space-y-2 text-xs">
                <div className="flex">
                  <span className="w-1/3 font-medium">Name</span>
                  <span className="w-2/3 text-gray-700">{invoice.customer_name}</span>
                </div>
                <div className="flex">
                  <span className="w-1/3 font-medium">Phone</span>
                  <span className="w-2/3 text-gray-700">
                    {invoice.country_code}
                    {invoice.customer_phone}
                  </span>
                </div>
                <div className="flex">
                  <span className="w-1/3 font-medium">ID</span>
                  <span className="w-2/3 text-gray-700">{invoice.customer_id}</span>
                </div>
              </div>
            </div>

            {/* Delivery Info Card */}
            <div className="bg-white rounded-lg border border-gray-200 p-3 shadow-sm">
              <div className="border-b border-gray-100 pb-2 mb-2">
                <h3 className="font-semibold text-sm text-gray-800">Delivery Information</h3>
              </div>
              <div className="space-y-2 text-xs">
                <div className="flex">
                  <span className="w-1/3 font-medium">Company</span>
                  <span className="w-2/3 text-gray-700">{filteredDeliveryInfo?.company_name}</span>
                </div>
                <div className="flex">
                  <span className="w-1/3 font-medium">Receiver</span>
                  <span className="w-2/3 text-gray-700">{invoice?.delivery_customer_name}</span>
                </div>
                <div className="flex">
                  <span className="w-1/3 font-medium">Phone</span>
                  <span className="w-2/3 text-gray-700">{invoice.delivery_customer_phone}</span>
                </div>
                <div className="flex">
                  <span className="w-1/3 font-medium">Address</span>
                  <span className="w-2/3 text-gray-700 break-words">{invoice.delivery_customer_address}</span>
                </div>
                <div className="flex">
                    {
                      user.id === 254 && invoice.custom_invoice_id !== null?
                      <p className="flex flex-row gap-1">
                        {" "}
                        <span className="w-1/3 font-medium">Invoice No</span> :{" "}
                        <span className="w-2/3 text-gray-700">{invoice.custom_invoice_id}{" "}</span>
                      </p>
                      : <p className="flex flex-row gap-1">
                        {" "}
                        <span className="font-semibold">Invoice No</span> :{" "}
                        <span className="w-2/3 text-gray-700">{invoice.invoice_id}{" "}</span>
                      </p>
                    }
                </div>
                <div className="flex">
                  <span className="w-1/3 font-medium">Date</span>
                  <span className="w-2/3 text-gray-700">{formattedDateTime}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Desktop Layout */}
          <div className="hidden md:block text-black space-y-[6px] font-nunito text-base w-auto">
            <p>
              <span className="font-semibold">Bill to,</span> <br />
              <span className="font-semibold">Customer Name </span> : {invoice.customer_name}
            </p>
            <p>
              <span className="font-semibold">Customer Phone</span> : {invoice.country_code}
              {invoice.customer_phone}
            </p>
            <p>
              <span className="font-semibold">Customer ID </span> : {invoice.customer_id}
            </p>
            {console.log("Courier ................... ", invoice?.stead_fast_courier)}
                  {
                    invoice?.stead_fast_courier ?
                    <>
                      <p>
                        <span className="font-semibold"> Consignment ID </span> :{" "}
                        {invoice?.stead_fast_courier?.consignment_id}
                      </p>
                      <p>
                        <span className="font-semibold"> Tracking Code </span> :{" "}
                        {invoice?.stead_fast_courier?.tracking_code}
                      </p>

                    </> : null
                  }
            {invoice.remarks && invoice.remarks.trim() !== "" && (
              <p>
                <span className="font-semibold">Remarks</span>: {invoice.remarks}
              </p>
            )}
          </div>

          <div className="hidden md:flex md:flex-col md:justify-start md:items-start text-black space-y-[4px] font-nunito text-base w-auto">
            <p className="flex flex-row gap-1">
              <span className="font-semibold whitespace-nowrap">Delivery Company</span> :
              <span>{filteredDeliveryInfo?.company_name}</span>
            </p>
            <p className="flex flex-row gap-1">
              <span className="font-semibold whitespace-nowrap">Receiver Name</span> :
              <span className="break-words">{invoice?.delivery_customer_name}</span>
            </p>
            <p className="flex flex-row gap-1">
              <span className="font-semibold whitespace-nowrap">Receiver Phone </span> :
              <span>{invoice.delivery_customer_phone}</span>
            </p>
            <p className="flex flex-row gap-1">
              <span className="font-semibold whitespace-nowrap">Receiver Address</span> :
              <span className="break-words">{invoice.delivery_customer_address}</span>
            </p>
                    {
                      user.id === 254 && invoice.custom_invoice_id !== null?
                      <p className="flex flex-row gap-1">
                        {" "}
                        <span className="font-semibold">Invoice No</span> :{" "}
                        {invoice.custom_invoice_id}{" "}
                      </p>
                      : <p className="flex flex-row gap-1">
                        {" "}
                        <span className="font-semibold">Invoice No</span> :{" "}
                        {invoice.invoice_id}{" "}
                      </p>
                    }
            <p className="flex flex-row gap-1">
              <span className="font-semibold">Date</span> : {formattedDateTime}
            </p>
          </div>
        </div>
        {/* Rest of the invoice content remains the same */}
        <div className="mx-auto w-full overflow-x-auto mt-4 mb-0">
          <table className="table min-w-full border-b-4 border-blue-300">
            <thead id="pdfContentTHead">
              <tr className="leading-normal text-[10px] sm:text-xs lg:text-base font-nunito tracking-wide border-b-4 border-t-4 border-blue-300">
                <th className="font-nunito text-left" style={{ padding: "3px 5px" }}>
                  SL
                </th>
                <th className="font-nunito text-start " style={{ padding: "3px 5px" }}>
                  Item Name
                </th>
                <th className="font-nunito text-center" style={{ padding: "3px 5px" }}>
                  Warranty
                </th>
                <th className="font-nunito text-center" style={{ padding: "3px 5px" }}>
                  Quantity
                </th>
                <th className="font-nunito text-right" style={{ padding: "3px 5px" }}>
                  Price
                </th>
                <th className="font-nunito text-right " style={{ padding: "3px 5px" }}>
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {/* <Watermark watermark_text={invoiceSetting?.watermark_text} watermark_type={invoiceSetting?.watermark_type}></Watermark> */}
              {(() => {
                let rowCounter = 0 // Define rowCounter outside the map function

                return invoice.sales_details.map((item) => {
                  const productId = item.product_id

                  // Skip if the product_id has already been processed
                  if (processedProductIds.has(productId)) {
                    return null
                  }

                  // Retrieve unique IMEIs and their details for the current product_id
                  const imeisDetails = imeisByProduct.filter((imeiDetail) => imeiDetail.product_id === productId)
                  let subtotalPrice = 0

                  if (imeisDetails.length > 0) {
                    const qty = imeisDetails.length // Number of unique IMEIs found for the product
                    totalItems += qty

                    // Calculate the total sale price for all unique IMEIs
                    const sumPrice = imeisDetails.reduce((acc, imei) => acc + imei.sale_price, 0)
                    subtotalPrice = sumPrice
                    totalPrice += subtotalPrice

                    // Mark this product_id as processed to avoid duplication
                    processedProductIds.add(productId)
                  } else {
                    subtotalPrice = formatPrice(
                      (item?.remaining_qty !== null && item?.remaining_qty !== undefined
                        ? item?.remaining_qty
                        : item?.qty) * item.price,
                    ) // Calculate subtotal price for the product
                    totalQty += Number(
                      item?.remaining_qty !== null && item?.remaining_qty !== undefined
                        ? item?.remaining_qty
                        : item?.qty,
                    ) // Add the quantity of the product
                    totalItems +=
                      item?.remaining_qty !== null && item?.remaining_qty !== undefined
                        ? item?.remaining_qty
                        : item?.qty // Count this product as a single item
                    totalPrice += Number(subtotalPrice) // Add to the total price
                  }

                  // Render rows for IMEIs or the regular item row
                  return imeisDetails?.length ? (
                    imeisDetails?.map((imei) => {
                      rowCounter += 1 // Increment for each IMEI row

                      return (
                        <tr
                          key={imei.id}
                          className="font-nunito border-[#E7EBF4] font-normal text-sm lg:text-base relative pt-3 pb-3"
                        >
                          <td className="text-left " style={{ padding: "6px 5px" }}>
                            {rowCounter}
                          </td>{" "}
                          {/* SL # */}
                          <td className="" style={{ padding: "6px 5px" }}>
                            {imei?.product_name} {imei?.optional_name} {imei?.color}{" "}
                            {imei?.storage ? `${imei.storage}GB` : ""}{" "}
                            {imei?.battery_life ? `BH-${imei.battery_life}%` : ""}{" "}
                            {imei?.regeion} {imei?.box_status}
                            <br />
                            <span className="text-[14px] font-semibold">
                              {item?.product_imei?.length > 0
                                ? `SL/IMEI : ${item?.product_imei[0]?.imei}`
                                : item?.product_info?.serial}
                            </span>
                            <span className="text-[13px]">
                              {item?.product_variant?.name
                                ? item?.product_variant?.name
                                : ""}
                            </span>
                          </td>
                          <td className="text-center " style={{ padding: "6px 5px" }}>
                            {/* Warranty Logic */}
                            {invoice.defaultwarranties &&
                              invoice.defaultwarranties.map(
                                (warrantyItem) =>
                                  warrantyItem.invoice_id === invoice.invoice_id &&
                                  warrantyItem.product_id === item.product_id &&
                                  (warrantyItem.warranty_id == null ? (
                                    <h1 className="">
                                      {warrantyItem?.default_warranties_count || ""}{" "}
                                      {item?.product_info?.warrenty || ""}
                                    </h1>
                                  ) : (
                                    <h1 className="">
                                      {warrantyItem?.warranty?.warranties_count || ""}{" "}
                                      {warrantyItem?.warranty?.name || ""}
                                    </h1>
                                  )),
                              )}
                          </td>
                          <td className="text-center " style={{ padding: "6px 5px" }}>
                            {"1"}
                          </td>
                          <td className="text-right" style={{ padding: "6px 5px" }}>
                            {imei.sale_price}
                          </td>
                          <td className="text-right font-semibold md:font-semibold " style={{ padding: "6px 5px" }}>
                            {imei.sale_price}
                            {invoiceSetting?.currency_info?.code || " BDT"}
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr
                      key={item.id}
                      className="font-nunito border-[#E7EBF4] font-normal text-sm lg:text-base relative"
                    >
                      <td className="text-left " style={{ padding: "6px 5px" }}>
                        {++rowCounter}
                      </td>{" "}
                      {/* SL # */}
                      <td className="" style={{ padding: "6px 5px" }}>
                        {item?.product_info?.name} <br />
                        <span className="text-[13px]">{item?.product_info?.serial}</span>
                        <span className="text-[13px]">
                              {item?.product_variant?.name
                                ? item?.product_variant?.name
                                : ""}
                        </span>
                      </td>
                      <td className="text-right " style={{ padding: "6px 5px" }}>
                        {/* Warranty Logic */}
                        {invoice.defaultwarranties &&
                          invoice.defaultwarranties.map(
                            (warrantyItem) =>
                              warrantyItem.invoice_id === invoice.invoice_id &&
                              warrantyItem.product_id === item.product_id &&
                              (warrantyItem.warranty_id == null ? (
                                <h1 className="">
                                  {warrantyItem?.default_warranties_count || ""} {item?.product_info?.warrenty || ""}
                                </h1>
                              ) : (
                                <h1 className="">
                                  {warrantyItem?.warranty?.warranties_count || ""} {warrantyItem?.warranty?.name || ""}
                                </h1>
                              )),
                          )}
                      </td>
                      {console.log("quantity Delivery", item?.remaining_qty)}
                      <td className="text-center " style={{ padding: "6px 5px" }}>
                        {item?.remaining_qty !== null && item?.remaining_qty !== undefined
                          ? item?.remaining_qty
                          : item?.qty}
                      </td>
                      <td className="text-right " style={{ padding: "6px 5px" }}>
                        {item.price}
                      </td>
                      <td className="text-right font-semibold md:font-semibold " style={{ padding: "6px 5px" }}>
                        {subtotalPrice}
                        {invoiceSetting?.currency_info?.code || " BDT"}
                      </td>
                    </tr>
                  )
                })
              })()}
            </tbody>
          </table>
        </div>
        {/* ------------------- */}
        <div className="w-full flex flex-col md:flex-row justify-between pt-0 ml-auto">
          <div style={styles.paymentMethodPrintDiv} className="mb-4 md:mb-0 self-center md:self-auto">
            <div>
              {invoice?.multiple_payment?.length > 0 ? (
                <span style={{ letterSpacing: "0.08em" }}>
                  Paid by{" "}
                  {invoice.multiple_payment
                    .map((payment) => payment.payment_type?.type_name)
                    .join(", ")
                    .replace(/, ([^,]*)$/, " and $1")}
                </span>
              ) : (
                <span>No payment information available</span>
              )}
            </div>
          </div>

          <div className="w-full md:w-1/3 text-xs font-semibold pl-0 md:pl-10">
            <div className="space-y-[2px] mb-2">
              <p className="flex justify-between">
                <span className="">Sub Total</span>
                <span>
                  {formatPrice(totalPrice)}
                  {invoiceSetting?.currency_info?.code ? invoiceSetting?.currency_info?.code : " BDT"}
                </span>
              </p>
              <p className="flex justify-between">
                <span className="">Discount</span>
                <span>
                  {formatPrice(invoice.discount ? invoice.discount : 0)}
                  {invoiceSetting?.currency_info?.code ? invoiceSetting?.currency_info?.code : " BDT"}
                </span>
              </p>
              <p className="flex justify-between">
                <span className="">Delivery Charge</span>
                <span>
                  {formatPrice(invoice.delivery_fee ? invoice.delivery_fee : 0)}
                  {invoiceSetting?.currency_info?.code ? invoiceSetting?.currency_info?.code : " BDT"}
                </span>
              </p>
            </div>
            <div style={{ borderTop: "0.5px solid #D3D3D3", margin: "10px 0" }}></div>
            <div className="my-2">
              <p className="flex justify-between">
                <span className="">Grand Total</span>
                <span>
                  {Number.parseFloat(
                    Number(totalPrice) + Number(invoice?.vat) + Number(invoice?.tax) + Number(invoice?.delivery_fee),
                  ) - Number(invoice?.discount).toFixed(2)}
                  {invoiceSetting?.currency_info?.code ? invoiceSetting?.currency_info?.code : " BDT"}
                </span>
              </p>
              <p className="flex justify-between">
                <span className="">Paid Amount</span>
                <span>
                  {invoice.paid_amount && invoice.paid_amount != "" ? formatPrice(invoice.paid_amount) : formatPrice(0)}
                  {invoiceSetting?.currency_info?.code ? invoiceSetting?.currency_info?.code : " BDT"}
                </span>
              </p>
            </div>
            <div style={{ borderTop: "0.5px solid #D3D3D3", margin: "10px 0" }}></div>
            <p className="flex justify-between mt-2">
              <span className="">Due Amount</span>
              <span>
                {Number.parseFloat(
                  Number(totalPrice) +
                    Number(invoice?.vat) +
                    Number(invoice?.tax) +
                    Number(invoice?.delivery_fee) -
                    Number(invoice?.discount) -
                    Number(
                      invoice.paid_amount && invoice.paid_amount != ""
                        ? formatPrice(invoice.paid_amount)
                        : formatPrice(0),
                    ),
                ).toFixed(2)}
                {invoiceSetting?.currency_info?.code ? invoiceSetting?.currency_info?.code : " BDT"}
              </span>
            </p>
          </div>
        </div>
        {/* ----------------- */}
        {/* amount in words */}
        <p className="text-gray-900 mt-4 font-nunito text-[10px] sm:text-xs lg:text-base font-semibold leading-normal text-center">
          <span style={{ color: "#A0AEC0" }}>In Word:</span>{" "}
          {numberToWords(formatPrice(invoiceCalculate(invoice).grandTotal))} taka only
        </p>
        <div style={{ ...styles.div }}>
          <p className="text-white font-nunito text-xs font-bold">
            You saved {formatPrice(invoice.discount ? invoice.discount : 0)}
            {/* You saved {invoice.discount ? invoice.discount : 0} */}
            {invoiceSetting?.currency_info?.code ? invoiceSetting?.currency_info?.code : " BDT"} in this purchase{" "}
          </p>
        </div>
        {/* ------------ */}
        {/* web address qr code */}
        <QRCode
          className="w-[50px] object-contain p-0 mt-5"
          value={
            invoice?.user_info?.web_address ||
            invoice?.user_info?.invoice_settings?.web_address ||
            "No Web Address set to the QR code"
          }
          size={50}
        />
        {/* ---------- */}
        {/* Terms and Conditions Section */} {/* Signature Section */}
        <div className="flex flex-col md:flex-row md:space-x-4 text-[10px] md:text-sm lg:text-base">
          <div className="pt-2 w-full md:w-1/2 mb-4 md:mb-0">
            <h3 className="text-[10px] font-semibold text-gray-800 mb-2">Terms and Conditions</h3>
            <ul className="list-disc list-inside text-gray-700 text-[10px]">
              {inputs.map((item, index) => (
                <li key={item.id || index}>{item.description}</li>
              ))}
            </ul>
          </div>
          <div className="p-4 flex text-xs flex-col items-center md:items-end w-full md:w-1/2">
            <div className="flex justify-center md:justify-end items-center">
              <div className="flex flex-col items-center border-t border-gray-300">
                <hr className="w-full" />
                <span>Authorized Signature</span>
              </div>
            </div>
          </div>
        </div>
        {/* footer */}
        <div className="text-center font-nunito mt-4 text-xs md:text-sm lg:text-base">
          <h2 className="text-orange-500 text-lg sm:text-xl font-semibold">Thanks for purchase</h2>
          <p className="text-black mt-2 text-[10px] sm:text-xs">A Product of SQUAD INNOVATORS </p>
        </div>
      </div>
    </div>
  )
}

const styles = {
  div: {
    backgroundColor: "#407BFF",
    color: "white",
    WebkitPrintColorAdjust: "exact",
    padding: "10px 10px 10px 10px",
    textAlign: "center",
    margin: "10px 0px 10px 0px",
  },
  paymentMethodDiv: {
    transform: "rotate(-45deg)",
    padding: "10px",
    textAlign: "center",
    // backgroundColor: '#407BFF',
    color: "black",
    // WebkitPrintColorAdjust: 'exact',
    margin: "30px 30px 20px 180px",
    maxWidth: "120px",
    wordWrap: "break-word",
    overflow: "hidden",
    fontSize: "13px",
  },
  paymentMethodPrintDiv: {
    transform: "rotate(-45deg)",
    padding: "10px",
    textAlign: "center",
    // backgroundColor: '#407BFF',
    color: "black",
    // WebkitPrintColorAdjust: 'exact',
    margin: "30px 30px 20px 180px",
    maxWidth: "120px",
    wordWrap: "break-word",
    overflow: "hidden",
    fontSize: "10px",
  },
}

export default DeliveryInvoice
